import { useNavigate } from 'react-router-dom';
import { eventsRoute } from 'basics/constants/routes.constants';
import { getConfigVar } from 'config/config';
import { useCurrentUserState } from 'contexts/user';

const useHomePage = () => {
  const { user } = useCurrentUserState();
  const navigate = useNavigate();

  const handleNavigateToMaya = () => {
    window.open(getConfigVar('REACT_APP_MAYA_URL'), '_self');
  };

  const handleNavigateToEvents = () => {
    navigate(eventsRoute);
  };

  return {
    handleNavigateToMaya,
    handleNavigateToEvents,
    user,
  };
};

export default useHomePage;
